import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as actionsUi from './kontakte.actions.ui';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {UuidService} from '@orga-app/providers/uuid.service';
import * as fromSelector from './kontakte.selector';
import {PageState} from './kontakte.reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {ActionSheetController, IonInput, LoadingController, ModalController, NavController, Platform} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {ItemWrapper, ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {Funktionsbereich, Kontakt, KontaktDetail, KontaktTelefon} from '../../../clients/kontaktverwaltung';
import {AktuellenKontaktAendernAction, AktuellenKontaktSetzenAction, AktuelleTelefonnummerAendernAction, AktuelleTelefonnummerSetzenAction, ExternerKontaktToggleAction, KontaktAktivToggleAction, KontaktBearbeitungAbbrechenAction, KontaktLoeschenAction, KontaktSpeichernAction, NeueTelefonnummerAction, TelefonnummerBearbeitungAbbrechenAction, TelefonnummerLoeschenAction, TelefonnummerSpeichernAction} from './kontakte.actions.ui';
import * as apiVeranstaltungen from '../../../clients/veranstaltungen';
import {takeWhile} from 'rxjs/operators';
import {DocumentService} from '@orga-app/providers/document.service';
import {NotificationService} from '@orga-app/providers/notification.service';


@Component({
    selector: 'page-kontakteverwaltung',
    templateUrl: 'kontakte.page.html'
})

export class KontaktePage implements OnInit, OnDestroy {
    @ViewChild('kontaktVornameInput', {static: false}) kontaktVornameInput: IonInput;

    aktuellerTab = 'Kontaktdaten';

    alive = true;

    // MANDANTEN OPTIONEN
    public istPandemieLizenzAktiv$: Observable<boolean>;

    funktionsbereicheKontakteListe$: Observable<Array<ListInputItem>>;
    funktionsbereicheKontakteListeLaden$: Observable<boolean>;
    funktionsbereicheKontakteListeFehler$: Observable<boolean>;

    aktuellerFunktionsbereich$: Observable<Funktionsbereich>;
    aktuellerKontakt$: Observable<Kontakt>;

    kontaktDetail$: Observable<KontaktDetail>;
    kontaktDetailLaden$: Observable<boolean>;
    kontaktDetailFehler$: Observable<boolean>;

    kontaktTelefone$: Observable<Array<ListInputItem>>;
    kontaktTelefoneLaden$: Observable<boolean>;
    kontaktTelefoneFehler$: Observable<boolean>;

    aktuelleTelefonnummer$: Observable<KontaktTelefon>;

    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'KontaktePage';

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                public platform: Platform,
                private uuid: UuidService,
                private store: Store<PageState>,
                public settingsProvider: SettingsProvider,
                private actionSheetCtrl: ActionSheetController,
                private loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private notificationService: NotificationService
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.funktionsbereicheKontakteListe$ = this.store.pipe(select(fromSelector.getFunktionsbereicheKontakteListe));
        this.funktionsbereicheKontakteListeLaden$ = this.store.pipe(select(fromSelector.getFunktionsbereicheKontakteListeLaden));
        this.funktionsbereicheKontakteListeFehler$ = this.store.pipe(select(fromSelector.getFunktionsbereicheKontakteListeFehler));

        this.aktuellerFunktionsbereich$ = this.store.pipe(select(fromSelector.getAktuellerFunktionsbereich));
        this.aktuellerKontakt$ = this.store.pipe(select(fromSelector.getAktuellerKontakt));

        this.kontaktDetail$ = this.store.pipe(select(fromSelector.getKontaktDetail));
        this.kontaktDetailLaden$ = this.store.pipe(select(fromSelector.getKontaktDetailLaden));
        this.kontaktDetailFehler$ = this.store.pipe(select(fromSelector.getKontaktDetailFehler));

        this.kontaktTelefone$ = this.store.pipe(select(fromSelector.getKontaktTelefonnummern));
        this.kontaktTelefoneLaden$ = this.store.pipe(select(fromSelector.getKontaktTelefonnummernLaden));
        this.kontaktTelefoneFehler$ = this.store.pipe(select(fromSelector.getKontaktTelefonnummernFehler));

        this.aktuelleTelefonnummer$ = this.store.pipe(select(fromSelector.getAktuelleTelefonnummer));
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    funktionsbereicheKontakteLaden() {
        this.store.dispatch(new actionsUi.FunktionsbereichKontakteLadenAction());
    }

    async kontaktAuswaehlen($event: { kontakt: Kontakt, funktionsbereich: Funktionsbereich }) {
        this.store.dispatch(new AktuellenKontaktSetzenAction($event.kontakt));
        setTimeout(() => {
            if (this.kontaktVornameInput !== null && this.kontaktVornameInput !== undefined) {
                this.kontaktVornameInput.setFocus();
            }
        }, 500);
    }

    async neuerKontakt(funktionsbereichsId: string) {
        this.store.dispatch(new actionsUi.NeuerKontaktAction(funktionsbereichsId));
        setTimeout(() => {
            if (this.kontaktVornameInput !== null && this.kontaktVornameInput !== undefined) {
                this.kontaktVornameInput.setFocus();
            }
        }, 500);
    }

    kontaktSpeichern() {
        this.store.dispatch(new KontaktSpeichernAction());
    }

    kontaktEntfernen() {
        this.store.dispatch(new KontaktLoeschenAction());
    }

    kontaktDetailAendernInput($event, kontakt: KontaktDetail, propName: string = null, propTyp: string = null) {
        if (kontakt !== null) {
            this.store.dispatch(new AktuellenKontaktAendernAction(this.mergeInput($event, kontakt, propName, propTyp)));
        }
    }

    telefonnummerAendernInput($event, telefon: KontaktTelefon, propName: string = null, propTyp: string = null) {
        if (telefon !== null) {
            this.store.dispatch(new AktuelleTelefonnummerAendernAction(this.mergeInput($event, telefon, propName, propTyp)));
        }
    }

    mergeInput<T>($event, obj: T, propName: string = null, propTyp: string = null) {
        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                obj = Object.assign({}, obj, {[propName]: $event.value});
            } else if (propTyp === 'checkbox') {
                // Checkbox
                obj = Object.assign({}, obj, {[propName]: $event.detail.checked});
            } else if (propTyp === 'toggle') {
                // Toggle
                obj = Object.assign({}, obj, {[propName]: $event.detail.checked});
            } else if (propTyp === 'input') {
                // Input
                if ($event.code !== 'Tab') {
                    obj = Object.assign({}, obj, {[propName]: $event.target.value});
                }
            } else if (propTyp === 'area') {
                // Area
                obj = Object.assign({}, obj, {[propName]: $event.target.textContent});
            } else if (propTyp === 'range') {
                // Range
                obj = Object.assign({}, obj, {[propName]: $event.detail.value});
            } else {
                // SELECT
                obj = Object.assign({}, obj, {[propName]: $event});
            }
        }

        return obj;
    }


    telefonGewaehlt($event: KontaktTelefon) {
        this.store.dispatch(new AktuelleTelefonnummerSetzenAction($event));
    }

    telefonnummerEntfernen() {
        this.store.dispatch(new TelefonnummerLoeschenAction());
    }

    telefonnummerHinzufuegen() {
        this.store.dispatch(new NeueTelefonnummerAction());
    }

    changeIstExtern($event, detail: KontaktDetail) {
        if ($event.target.checked !== detail.ist_extern) {
            this.store.dispatch(new ExternerKontaktToggleAction($event.detail.checked));
        }
    }

    changeIstAktiv($event, detail: KontaktDetail) {
        if ($event.target.checked !== detail.ist_aktiv) {
            this.store.dispatch(new KontaktAktivToggleAction($event.detail.checked));
        }
    }

    kontaktAbbrechen() {
        this.store.dispatch(new KontaktBearbeitungAbbrechenAction());
    }

    telefonAbbrechen() {
        this.store.dispatch(new TelefonnummerBearbeitungAbbrechenAction());
    }

    telefonnummerSpeichern() {
        this.store.dispatch(new TelefonnummerSpeichernAction());
    }

    trackByKontaktItem(index, item: ItemWrapper) {
        return item.id + item.selected;
    }

    async kontaktAuswaehlen2(kontakt: Kontakt) {
        this.store.dispatch(new AktuellenKontaktSetzenAction(kontakt));
        setTimeout(() => {
            if (this.kontaktVornameInput !== null && this.kontaktVornameInput !== undefined) {
                this.kontaktVornameInput.setFocus();
            }
        }, 500);
    }

    async exportContacts() {
        const buttons = [
            {
                text: 'Kontaktliste als PDF',
                handler: () => {
                    this.dateiOeffnen(1);
                }
            },
            {
                text: 'Kontaktliste als Excel',
                handler: () => {
                    this.dateiOeffnen(2);
                }
            },
            {text: 'Abbrechen',
                icon: 'close',
                role: 'cancel'}
        ];

        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Wähle eine Variante',
            backdropDismiss: true,
            buttons
        });
        await actionSheet.present();
    }

    async dateiOeffnen(variante: number) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Kontaktliste wird geladen'
        });
        await loading.present();

        let url = '/api/query/kontaktverwaltung/kontakte/funktionsbereiche/kontakte';
        if (variante === 1) {
            url += '/pdf';
        }
        if (variante === 2) {
            url += '/excel';
        }
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    const date = new Date();
                    await this.documentService.saveFile(doc, date.getFullYear() + '_' + date.getMonth() + '_' + date.getDate() + '_kontaktliste');
                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });
    }


    ngOnDestroy(): void {
        this.alive = false;
    }
}
